
import Pay from '@/components/payComment/payIndex.vue'
import {computed, defineComponent, onMounted, onUnmounted, onUpdated, reactive, ref} from 'vue'
import {CountDown, Dialog, Toast} from 'vant';
import CardItem from './components/ServiceFeeCard.vue'
import {areaList} from '@vant/area-data';
import {cancelOrder} from '@/api/reportFee'
import {getOrderDetail} from '@/api/serviceFee'
import {useRoute, useRouter} from "vue-router";
import {useStore} from 'vuex'

export default defineComponent({
  name: 'ServiceFeePaySure',
  components: {
    CardItem,
    Pay,
    CountDown
  },
  props: {},
  setup() {
    const area = ref('')
    const router = useRouter()
    const route = useRoute();
    let planText = ref('')
    const store = useStore()
    store.commit('hidePaying')

    //表单数据
    const cancel = ref(false);
    let fee = reactive({
      info: {},
      orderInfo: {},
      countTime: '',
      returnUrl: location.href,
      params: {
        serviceFeeId: "",
      },
      dossierInfo: {},
    })
    const showPlan = (): void => {
      Dialog.alert({
        title: '计划说明',
        message: planText.value,
        confirmButtonColor: '#157CFF',
        messageAlign: 'left'
      }).then(() => {
        // on close
      });
    }

    // 生命周期
    onMounted(async () => {
      if (route.query.orderNumber) {
        cancel.value = true
        let info = await getOrderDetail(route.query.orderNumber)
        info['name'] = info['name']
        info['itemList'] = info['itemList'].map(item => {
          let val = item
          val.isChecked = true
          return val
        })
        fee.info = info
        fee.dossierInfo = info['dossierInfo'];
        if (fee.info['cancelOrderCountdown'] == 0) {
          router.replace({
            name: 'ServiceFeeBuy',
            query: {
              id: info['serviceFeeId']
            }
          })
        }

      }
      fee.info['itemList'].forEach(item => {
        item.feeType = fee.info['feeType']
      })
      planText.value = fee.info['remark']
      getAreaValue()
    })
    onUpdated(() => {
      console.log('updated vue3 typescript')
    })
    onUnmounted(() => {
      console.log('onUnmounted vue3 typescript')
    })

    const showPay = async () => {
      if (route.query['orderNumber'] || fee.info['orderNumber']) {
        fee.returnUrl = window.location.origin + `/service-fee?id=${fee.info['serviceFeeId']}`
        fee.orderInfo['orderNumber'] = fee.info['orderNumber']
        store.commit('showPaying')
        return
      }
    }
    const cancelPay = (): void => {
      Dialog.confirm({
        title: '提示',
        message: '确认要取消订单吗？',
        confirmButtonColor: '#157CFF',
      })
          .then(async () => {
            await cancelOrder(fee.info['orderId'])
            Toast("取消成功")
            router.replace({
              name: 'ServiceFeeBuy',
              query: {
                id: fee.info['serviceFeeId']
              }
            })
          })
          .catch(() => {
            // on cancel
          });
    }
    const getAreaValue = () => {
      let areaCode = []
      fee.info['feePlanUserFormVoList'].forEach(element => {
        if (element.fieldId == 7) {
          areaCode.push(element.fieldValue1)
          areaCode.push(element.fieldValue2)
        }
      });
      console.log(areaCode[0])
      areaCode[0] && areaCode[0] != 0 ? area.value = areaList.province_list[areaCode[0]] : area.value = ''
      areaCode[1] && areaCode[1] != 0 ? area.value += '/' + areaList.city_list[areaCode[1]] : area.value += ''

    }
    const getNumberTime = (timeData) => {
      if (timeData.total == 0) {
        router.replace({
          name: 'ServiceFeeBuy',
          query: {
            id: fee.info['serviceFeeId']
          }
        })
        return false
      }
      let hours
      hours = timeData.hours + (timeData.days * 24)
      return {
        hours: hours < 10 ? '0' + hours : hours,
        minutes: timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes,
        seconds: timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds
      }
    }
    const computePrice = computed(() => {
      if (!fee.info || !fee.info['itemList']) {
        return 0
      }
      let objArr = fee.info['itemList'].filter(item => {
        return item.isChecked
      })
      return objArr.reduce((total, v) => {
        return total + parseFloat(v.payablePrice)
      }, 0)
    })
    const payStart = () => {
      sessionStorage.removeItem('feeInfo')
    }
    // 暴露给模板
    return {
      showPlan,
      areaList,
      showPay,
      cancel,
      cancelPay,
      fee,
      computePrice,
      area,
      getNumberTime,
      payStart
    }
  },
  computed: {},
})
